import { render, staticRenderFns } from "./AddUpdateDialog.vue?vue&type=template&id=0a9e666e&scoped=true&"
import script from "./AddUpdateDialog.vue?vue&type=script&lang=js&"
export * from "./AddUpdateDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddUpdateDialog.vue?vue&type=style&index=0&id=0a9e666e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9e666e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a9e666e')) {
      api.createRecord('0a9e666e', component.options)
    } else {
      api.reload('0a9e666e', component.options)
    }
    module.hot.accept("./AddUpdateDialog.vue?vue&type=template&id=0a9e666e&scoped=true&", function () {
      api.rerender('0a9e666e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/special/components/AddUpdateDialog.vue"
export default component.exports